import vtkDataArray from "@kitware/vtk.js/Common/Core/DataArray";
import vtkMapper from "@kitware/vtk.js/Rendering/Core/Mapper";
import vtkColorTransferFunction from "@kitware/vtk.js/Rendering/Core/ColorTransferFunction";
import vtkActor from "@kitware/vtk.js/Rendering/Core/Actor";
import vtkPolyDataReader from '@kitware/vtk.js/IO/Legacy/PolyDataReader';
import vtkOBJReader from '@kitware/vtk.js/IO/Misc/OBJReader';
import vtkPolyData from "@kitware/vtk.js/Common/DataModel/PolyData";
import vtkPoints from "@kitware/vtk.js/Common/Core/Points";
import vtkCellArray from "@kitware/vtk.js/Common/Core/CellArray";
import vtkSphareMapper from "@kitware/vtk.js/Rendering/Core/SphereMapper";
import vtkTubeFilter from "@kitware/vtk.js/Filters/General/TubeFilter";
import vtkLineSource from "@kitware/vtk.js/Filters/Sources/LineSource";
import util from "@/util/util";
import colorUtil from "@/util/colorUtil";
import vtkRenderWindowWithControlBar from "@kitware/vtk.js/Rendering/Misc/RenderWindowWithControlBar";
import vtkSphereSource from "@kitware/vtk.js/Filters/Sources/SphereSource";
import vtkPointPicker from "@kitware/vtk.js/Rendering/Core/PointPicker";
import vtkOrientationMarkerWidget from '@kitware/vtk.js/Interaction/Widgets/OrientationMarkerWidget';
import vtkInteractiveOrientationWidget from '@kitware/vtk.js/Widgets/Widgets3D/InteractiveOrientationWidget';
import vtkWidgetManager from '@kitware/vtk.js/Widgets/Core/WidgetManager';
import * as vtkMath from '@kitware/vtk.js/Common/Core/Math';

const vtkUtil = {
    majorAxis(vec3, idxA, idxB) {
        const axis = [0, 0, 0];
        const idx = Math.abs(vec3[idxA]) > Math.abs(vec3[idxB]) ? idxA : idxB;
        const value = vec3[idx] > 0 ? 1 : -1;
        axis[idx] = value;
        return axis;
    },
    smallNav(renderer, renderWindow, actor){
        const orientationWidget = vtkOrientationMarkerWidget.newInstance({
            actor: actor,
            interactor: renderWindow.getInteractor(),
        });
        orientationWidget.setEnabled(true);
        orientationWidget.setViewportCorner(
            vtkOrientationMarkerWidget.Corners.TOP_RIGHT
        );
        orientationWidget.setViewportSize(0.3);
        orientationWidget.setMinPixelSize(100);
        orientationWidget.setMaxPixelSize(300);

        const camera = renderer.getActiveCamera();
        const widgetManager = vtkWidgetManager.newInstance();
        widgetManager.setRenderer(orientationWidget.getRenderer());

        const widget = vtkInteractiveOrientationWidget.newInstance();
        widget.placeWidget(actor.getBounds());
// widget.setBounds(axes.getBounds());
        widget.setPlaceFactor(1);

        const vw = widgetManager.addWidget(widget);

        vw.onOrientationChange(({  direction }) => {
            const focalPoint = camera.getFocalPoint();
            const position = camera.getPosition();
            const viewUp = camera.getViewUp();

            const distance = Math.sqrt(
                vtkMath.distance2BetweenPoints(position, focalPoint)
            );
            camera.setPosition(
                focalPoint[0] + direction[0] * distance,
                focalPoint[1] + direction[1] * distance,
                focalPoint[2] + direction[2] * distance
            );

            if (direction[0]) {
                camera.setViewUp(vtkUtil.majorAxis(viewUp, 1, 2));
            }
            if (direction[1]) {
                camera.setViewUp(vtkUtil.majorAxis(viewUp, 0, 2));
            }
            if (direction[2]) {
                camera.setViewUp(vtkUtil.majorAxis(viewUp, 0, 1));
            }

            orientationWidget.updateMarkerOrientation();
            widgetManager.enablePicking();
            renderWindow.render();
        });
        renderer.resetCamera();
        widgetManager.enablePicking();
        renderWindow.render();
    },
    bindLeftButtonPress(renderWindow, renderer, pointPicker, elementId, callBack){
        renderWindow.getInteractor().onLeftButtonPress((callData) => {
            if (renderer !== callData.pokedRenderer) {
                return;
            }
            const pos = callData.position;
            const point = [pos.x, pos.y, 0.0];
            var labelTop = document.getElementById(elementId).offsetHeight - pos.y + 80;
            var labelLeft = pos.x -180;

            pointPicker.pick(point, renderer);
            var actor = null;
            if (pointPicker.getActors().length > 0) {
                actor = pointPicker.getActors()[0];
            }
            callBack({
                labelLeft,
                labelTop,
                actor,
                pos
            })
        })
    },
    initPicker(){
        var pointPicker = vtkPointPicker.newInstance();
        pointPicker.setPickFromList(1);
        pointPicker.initializePickList();
        pointPicker.setTolerance(0.005);
        return pointPicker;
    },
    getSphereActorList(pointList, renderer){
        if (util.isNull(pointList)){
            return [];
        }
        var list = [];
        pointList.map(item => {
            const sphere = vtkSphereSource.newInstance();
            sphere.setCenter(item.px, item.py, item.pz);
            sphere.setRadius(0.5);
            const sphereMapper = vtkMapper.newInstance();
            sphereMapper.setInputData(sphere.getOutputData());
            const sphereActor = vtkActor.newInstance();
            sphereActor.setMapper(sphereMapper);
            sphereActor.getProperty().setColor(1.0, 0.0, 0.0);
            sphereActor.getProperty().set({cibrPoint: item, sphere: sphere}, true, true)
            list.push(sphereActor);
            renderer.addActor(sphereActor);
        });
        return list;
    },
    init3DWindow(id) {
        const fullScreenRenderer = vtkRenderWindowWithControlBar.newInstance();
        fullScreenRenderer.setControlSize(0)
        var renderer = fullScreenRenderer.getRenderer();
        renderer.setBackground(0, 0, 0, 0)
        fullScreenRenderer.setContainer(document.getElementById(id))
        var renderWindow = fullScreenRenderer.getRenderWindow();
        return {
            renderer,
            renderWindow
        }
    },
    getObjActor(url, callBack){
        const reader = vtkOBJReader.newInstance();
        reader.setUrl(url).then(() => {
            const size = reader.getNumberOfOutputPorts();
            var retActor = null;
            for (let i = 0; i < size; i++) {
                const polydata = reader.getOutputData(i);
                const mapper = vtkMapper.newInstance();
                const actor = vtkActor.newInstance();
                actor.setMapper(mapper);
                mapper.setInputData(polydata);
                retActor = actor;
            }
            callBack({actor : retActor});
        });
    },
    readObjMode(url, renderer, renderWindow, callBack) {
        const reader = vtkOBJReader.newInstance();
        reader.setUrl(url).then(() => {
            const size = reader.getNumberOfOutputPorts();
            for (let i = 0; i < size; i++) {
                const polydata = reader.getOutputData(i);
                const mapper = vtkMapper.newInstance();
                const actor = vtkActor.newInstance();
                actor.setMapper(mapper);
                actor.getProperty().setOpacity(0.1)
                mapper.setInputData(polydata);
                renderer.addActor(actor);
            }
            renderer.resetCamera();
            renderWindow.render();
            if (callBack != null) {
                callBack();
            }
        });
    },
    removePickerList(picker, actorList) {
        if (util.isNull(picker) || util.isNull(actorList)) {
            return;
        }
        actorList.map(item => {
            picker.removeActor(item)
        })
    },
    getVtkActor(url, callBack, renderer, renderWindow, actorId) {
        const reader = vtkPolyDataReader.newInstance();
        reader.setUrl(url).then(() => {
            const polydata = reader.getOutputData(0);
            let list = reader.toJSON().parseData.split("LOOKUP_TABLE default");
            let listElement = list[list.length - 1];
            let split = listElement.trim().split(/\s+/);
            let max = 1;
            let min = 0;
            var values = new Float32Array(split);
            const colors = vtkDataArray.newInstance({name: 'points', values});
            polydata.getPointData().setScalars(colors);
            const mapper = vtkMapper.newInstance({});
            var colorTransferFunction = vtkUtil.getColorTransferFunction();
            mapper.setLookupTable(colorTransferFunction);
            mapper.setScalarRange([min, max])
            mapper.setInputData(polydata);
            const actor = vtkActor.newInstance();
            actor.getProperty().set({"actorId": actorId}, true, true);
            actor.setMapper(mapper);
            actor.getProperty().setOpacity(0.01)
            renderer.addActor(actor);
            renderer.resetCamera();
            renderWindow.render();
            callBack(actor);
        });
    },
    getVtkActor2(url, callBack){
        const reader = vtkPolyDataReader.newInstance();
        reader.setUrl(url).then(() => {
            const polydata = reader.getOutputData(0);
            let list = reader.toJSON().parseData.split("LOOKUP_TABLE default");
            let listElement = list[list.length - 1];
            let split = listElement.trim().split(/\s+/);
            let max = 1;
            let min = 0;
            var values = new Float32Array(split);
            const colors = vtkDataArray.newInstance({name: 'points', values});
            polydata.getPointData().setScalars(colors);
            const mapper = vtkMapper.newInstance({});
            // const colorTransferFunction = vtkColorTransferFunction.newInstance();
            // colorTransferFunction.addRGBPoint(min, 0.231373,0.298039, 0.752941);
            // colorTransferFunction.addRGBPoint((max + min) /2, 0.865,0.865, 0.865);
            // colorTransferFunction.addRGBPoint(max, 0.705882,0.0156863, 0.14902);
            var colorTransferFunction = vtkUtil.getColorTransferFunction();
            mapper.setLookupTable(colorTransferFunction);
            mapper.setScalarRange([min, max])

            const actor = vtkActor.newInstance();
            actor.setMapper(mapper);
            // actor.getProperty().setOpacity(opacity)
            mapper.setInputData(polydata);
            callBack({actor});
        });
    },
    readVtkFile(url, renderer, renderWindow, opacity, callBack) {
        const reader = vtkPolyDataReader.newInstance();
        reader.setUrl(url).then(() => {
            const polydata = reader.getOutputData(0);
            let list = reader.toJSON().parseData.split("LOOKUP_TABLE default");
            let listElement = list[list.length - 1];
            let split = listElement.trim().split(/\s+/);
            let max = 1;
            let min = 0;
            var values = new Float32Array(split);
            const colors = vtkDataArray.newInstance({name: 'points', values});
            polydata.getPointData().setScalars(colors);
            const mapper = vtkMapper.newInstance({});
            // const colorTransferFunction = vtkColorTransferFunction.newInstance();
            // colorTransferFunction.addRGBPoint(min, 0.231373,0.298039, 0.752941);
            // colorTransferFunction.addRGBPoint((max + min) /2, 0.865,0.865, 0.865);
            // colorTransferFunction.addRGBPoint(max, 0.705882,0.0156863, 0.14902);
            var colorTransferFunction = vtkUtil.getColorTransferFunction();
            mapper.setLookupTable(colorTransferFunction);
            mapper.setScalarRange([min, max])

            const actor = vtkActor.newInstance();
            actor.setMapper(mapper);
            actor.getProperty().setOpacity(opacity)
            mapper.setInputData(polydata);
            renderer.addActor(actor);
            callBack({actor});
            renderWindow.render();
        });
    },
    getLineSourceActor(point1, point2, color, redius) {
        const line = vtkLineSource.newInstance({resolution: 10});
        line.setPoint1(point1)
        line.setPoint2(point2)
        var tubeFilter = vtkTubeFilter.newInstance();
        tubeFilter.setInputConnection(line.getOutputPort())
        tubeFilter.setRadius(redius);
        tubeFilter.setNumberOfSides(50);
        tubeFilter.setCapping(true);
        var actor = vtkActor.newInstance();
        var mapper = vtkMapper.newInstance();
        mapper.setInputData(tubeFilter.getOutputData());
        actor.setMapper(mapper);
        actor.getProperty().setColor(color)
        actor.getProperty().setLineWidth(2)
        return actor;
    },
    getLineActor(point1, point2, color) {
        var polyData = vtkPolyData.newInstance();
        var points = vtkPoints.newInstance();

        let numPoints = 2;
        let vertsArray = new Uint32Array(3);

        points.setNumberOfPoints(numPoints, 3);
        points.setPoint(0, point1[0], point1[1], point1[2]);
        points.setPoint(1, point2[0], point2[1], point2[2]);
        vertsArray[0] = 2
        vertsArray[1] = 0
        vertsArray[2] = 1

        var cellArray = vtkCellArray.newInstance();
        cellArray.setData(vertsArray);
        polyData.setPoints(points);
        polyData.setLines(cellArray);
        var tubeFilter = vtkTubeFilter.newInstance();
        tubeFilter.setInputConnection(polyData.getOutputPort())
        tubeFilter.setRadius(2.0);
        tubeFilter.setNumberOfSides(50);
        tubeFilter.setCapping(true);
        var actor = vtkActor.newInstance();
        var mapper = vtkSphareMapper.newInstance();
        mapper.setInputData(polyData);
        actor.setMapper(mapper);
        actor.getProperty().setColor(color)
        actor.getProperty().setLineWidth(20)
        return actor;
    },
    getColorTransferFunctionByColorUtil() {
        const colorTransferFunction = vtkColorTransferFunction.newInstance();
        colorUtil.colorList.map(item => {
            colorTransferFunction.addRGBPoint(item[0], item[1], item[2], item[3]);
        })
        return colorTransferFunction;
    },
    getColorTransferFunction() {
        const colorTransferFunction = vtkColorTransferFunction.newInstance();
        colorTransferFunction.addRGBPoint(0, 0, 0, 1)
        colorTransferFunction.addRGBPoint(0.003921569, 0, 0.023529412, 1)
        colorTransferFunction.addRGBPoint(0.007843137, 0, 0.047058824, 1)
        colorTransferFunction.addRGBPoint(0.011764706, 0, 0.070588235, 1)
        colorTransferFunction.addRGBPoint(0.015686275, 0, 0.094117647, 1)
        colorTransferFunction.addRGBPoint(0.019607843, 0, 0.117647059, 1)
        colorTransferFunction.addRGBPoint(0.023529412, 0, 0.141176471, 1)
        colorTransferFunction.addRGBPoint(0.02745098, 0, 0.164705882, 1)
        colorTransferFunction.addRGBPoint(0.031372549, 0, 0.188235294, 1)
        colorTransferFunction.addRGBPoint(0.035294118, 0, 0.211764706, 1)
        colorTransferFunction.addRGBPoint(0.039215686, 0, 0.235294118, 1)
        colorTransferFunction.addRGBPoint(0.043137255, 0, 0.258823529, 1)
        colorTransferFunction.addRGBPoint(0.047058824, 0, 0.282352941, 1)
        colorTransferFunction.addRGBPoint(0.050980392, 0, 0.305882353, 1)
        colorTransferFunction.addRGBPoint(0.054901961, 0, 0.329411765, 1)
        colorTransferFunction.addRGBPoint(0.058823529, 0, 0.352941176, 1)
        colorTransferFunction.addRGBPoint(0.062745098, 0, 0.376470588, 1)
        colorTransferFunction.addRGBPoint(0.066666667, 0, 0.4, 1)
        colorTransferFunction.addRGBPoint(0.070588235, 0, 0.423529412, 1)
        colorTransferFunction.addRGBPoint(0.074509804, 0, 0.447058824, 1)
        colorTransferFunction.addRGBPoint(0.078431373, 0, 0.470588235, 1)
        colorTransferFunction.addRGBPoint(0.082352941, 0, 0.494117647, 1)
        colorTransferFunction.addRGBPoint(0.08627451, 0, 0.517647059, 1)
        colorTransferFunction.addRGBPoint(0.090196078, 0, 0.541176471, 1)
        colorTransferFunction.addRGBPoint(0.094117647, 0, 0.564705882, 1)
        colorTransferFunction.addRGBPoint(0.098039216, 0, 0.588235294, 1)
        colorTransferFunction.addRGBPoint(0.101960784, 0, 0.611764706, 1)
        colorTransferFunction.addRGBPoint(0.105882353, 0, 0.635294118, 1)
        colorTransferFunction.addRGBPoint(0.109803922, 0, 0.658823529, 1)
        colorTransferFunction.addRGBPoint(0.11372549, 0, 0.682352941, 1)
        colorTransferFunction.addRGBPoint(0.117647059, 0, 0.705882353, 1)
        colorTransferFunction.addRGBPoint(0.121568627, 0, 0.729411765, 1)
        colorTransferFunction.addRGBPoint(0.125490196, 0, 0.752941176, 1)
        colorTransferFunction.addRGBPoint(0.129411765, 0, 0.776470588, 1)
        colorTransferFunction.addRGBPoint(0.133333333, 0, 0.8, 1)
        colorTransferFunction.addRGBPoint(0.137254902, 0, 0.823529412, 1)
        colorTransferFunction.addRGBPoint(0.141176471, 0, 0.847058824, 1)
        colorTransferFunction.addRGBPoint(0.145098039, 0, 0.870588235, 1)
        colorTransferFunction.addRGBPoint(0.149019608, 0, 0.894117647, 1)
        colorTransferFunction.addRGBPoint(0.152941176, 0, 0.917647059, 1)
        colorTransferFunction.addRGBPoint(0.156862745, 0, 0.941176471, 1)
        colorTransferFunction.addRGBPoint(0.160784314, 0, 0.956862745, 0.992156863)
        colorTransferFunction.addRGBPoint(0.164705882, 0, 0.968627451, 0.980392157)
        colorTransferFunction.addRGBPoint(0.168627451, 0, 0.980392157, 0.968627451)
        colorTransferFunction.addRGBPoint(0.17254902, 0, 0.992156863, 0.956862745)
        colorTransferFunction.addRGBPoint(0.176470588, 0, 1, 0.941176471)
        colorTransferFunction.addRGBPoint(0.180392157, 0, 1, 0.917647059)
        colorTransferFunction.addRGBPoint(0.184313725, 0, 1, 0.894117647)
        colorTransferFunction.addRGBPoint(0.188235294, 0, 1, 0.870588235)
        colorTransferFunction.addRGBPoint(0.192156863, 0, 1, 0.847058824)
        colorTransferFunction.addRGBPoint(0.196078431, 0, 1, 0.823529412)
        colorTransferFunction.addRGBPoint(0.2, 0, 1, 0.8)
        colorTransferFunction.addRGBPoint(0.203921569, 0, 1, 0.776470588)
        colorTransferFunction.addRGBPoint(0.207843137, 0, 1, 0.752941176)
        colorTransferFunction.addRGBPoint(0.211764706, 0, 1, 0.729411765)
        colorTransferFunction.addRGBPoint(0.215686275, 0, 1, 0.705882353)
        colorTransferFunction.addRGBPoint(0.219607843, 0, 1, 0.682352941)
        colorTransferFunction.addRGBPoint(0.223529412, 0, 1, 0.658823529)
        colorTransferFunction.addRGBPoint(0.22745098, 0, 1, 0.635294118)
        colorTransferFunction.addRGBPoint(0.231372549, 0, 1, 0.611764706)
        colorTransferFunction.addRGBPoint(0.235294118, 0, 1, 0.588235294)
        colorTransferFunction.addRGBPoint(0.239215686, 0, 1, 0.564705882)
        colorTransferFunction.addRGBPoint(0.243137255, 0, 1, 0.541176471)
        colorTransferFunction.addRGBPoint(0.247058824, 0, 1, 0.517647059)
        colorTransferFunction.addRGBPoint(0.250980392, 0, 1, 0.494117647)
        colorTransferFunction.addRGBPoint(0.254901961, 0, 1, 0.470588235)
        colorTransferFunction.addRGBPoint(0.258823529, 0, 1, 0.447058824)
        colorTransferFunction.addRGBPoint(0.262745098, 0, 1, 0.423529412)
        colorTransferFunction.addRGBPoint(0.266666667, 0, 1, 0.4)
        colorTransferFunction.addRGBPoint(0.270588235, 0, 1, 0.376470588)
        colorTransferFunction.addRGBPoint(0.274509804, 0, 1, 0.352941176)
        colorTransferFunction.addRGBPoint(0.278431373, 0, 1, 0.329411765)
        colorTransferFunction.addRGBPoint(0.282352941, 0, 1, 0.305882353)
        colorTransferFunction.addRGBPoint(0.28627451, 0, 1, 0.282352941)
        colorTransferFunction.addRGBPoint(0.290196078, 0, 1, 0.258823529)
        colorTransferFunction.addRGBPoint(0.294117647, 0, 1, 0.235294118)
        colorTransferFunction.addRGBPoint(0.298039216, 0, 1, 0.211764706)
        colorTransferFunction.addRGBPoint(0.301960784, 0, 1, 0.188235294)
        colorTransferFunction.addRGBPoint(0.305882353, 0, 1, 0.164705882)
        colorTransferFunction.addRGBPoint(0.309803922, 0, 1, 0.141176471)
        colorTransferFunction.addRGBPoint(0.31372549, 0, 1, 0.117647059)
        colorTransferFunction.addRGBPoint(0.317647059, 0, 1, 0.094117647)
        colorTransferFunction.addRGBPoint(0.321568627, 0, 1, 0.070588235)
        colorTransferFunction.addRGBPoint(0.325490196, 0, 1, 0.047058824)
        colorTransferFunction.addRGBPoint(0.329411765, 0, 1, 0.023529412)
        colorTransferFunction.addRGBPoint(0.333333333, 0, 1, 0)
        colorTransferFunction.addRGBPoint(0.337254902, 0.023529412, 1, 0)
        colorTransferFunction.addRGBPoint(0.341176471, 0.047058824, 1, 0)
        colorTransferFunction.addRGBPoint(0.345098039, 0.070588235, 1, 0)
        colorTransferFunction.addRGBPoint(0.349019608, 0.094117647, 1, 0)
        colorTransferFunction.addRGBPoint(0.352941176, 0.117647059, 1, 0)
        colorTransferFunction.addRGBPoint(0.356862745, 0.141176471, 1, 0)
        colorTransferFunction.addRGBPoint(0.360784314, 0.164705882, 1, 0)
        colorTransferFunction.addRGBPoint(0.364705882, 0.188235294, 1, 0)
        colorTransferFunction.addRGBPoint(0.368627451, 0.211764706, 1, 0)
        colorTransferFunction.addRGBPoint(0.37254902, 0.235294118, 1, 0)
        colorTransferFunction.addRGBPoint(0.376470588, 0.258823529, 1, 0)
        colorTransferFunction.addRGBPoint(0.380392157, 0.282352941, 1, 0)
        colorTransferFunction.addRGBPoint(0.384313725, 0.305882353, 1, 0)
        colorTransferFunction.addRGBPoint(0.388235294, 0.329411765, 1, 0)
        colorTransferFunction.addRGBPoint(0.392156863, 0.352941176, 1, 0)
        colorTransferFunction.addRGBPoint(0.396078431, 0.376470588, 1, 0)
        colorTransferFunction.addRGBPoint(0.4, 0.4, 1, 0)
        colorTransferFunction.addRGBPoint(0.403921569, 0.423529412, 1, 0)
        colorTransferFunction.addRGBPoint(0.407843137, 0.447058824, 1, 0)
        colorTransferFunction.addRGBPoint(0.411764706, 0.470588235, 1, 0)
        colorTransferFunction.addRGBPoint(0.415686275, 0.494117647, 1, 0)
        colorTransferFunction.addRGBPoint(0.419607843, 0.517647059, 1, 0)
        colorTransferFunction.addRGBPoint(0.423529412, 0.541176471, 1, 0)
        colorTransferFunction.addRGBPoint(0.42745098, 0.564705882, 1, 0)
        colorTransferFunction.addRGBPoint(0.431372549, 0.588235294, 1, 0)
        colorTransferFunction.addRGBPoint(0.435294118, 0.611764706, 1, 0)
        colorTransferFunction.addRGBPoint(0.439215686, 0.635294118, 1, 0)
        colorTransferFunction.addRGBPoint(0.443137255, 0.658823529, 1, 0)
        colorTransferFunction.addRGBPoint(0.447058824, 0.682352941, 1, 0)
        colorTransferFunction.addRGBPoint(0.450980392, 0.705882353, 1, 0)
        colorTransferFunction.addRGBPoint(0.454901961, 0.729411765, 1, 0)
        colorTransferFunction.addRGBPoint(0.458823529, 0.752941176, 1, 0)
        colorTransferFunction.addRGBPoint(0.462745098, 0.776470588, 1, 0)
        colorTransferFunction.addRGBPoint(0.466666667, 0.8, 1, 0)
        colorTransferFunction.addRGBPoint(0.470588235, 0.823529412, 1, 0)
        colorTransferFunction.addRGBPoint(0.474509804, 0.847058824, 1, 0)
        colorTransferFunction.addRGBPoint(0.478431373, 0.870588235, 1, 0)
        colorTransferFunction.addRGBPoint(0.482352941, 0.894117647, 1, 0)
        colorTransferFunction.addRGBPoint(0.48627451, 0.917647059, 1, 0)
        colorTransferFunction.addRGBPoint(0.490196078, 0.941176471, 1, 0)
        colorTransferFunction.addRGBPoint(0.494117647, 0.956862745, 0.992156863, 0)
        colorTransferFunction.addRGBPoint(0.498039216, 0.968627451, 0.980392157, 0)
        colorTransferFunction.addRGBPoint(0.501960784, 0.980392157, 0.968627451, 0)
        colorTransferFunction.addRGBPoint(0.505882353, 0.992156863, 0.956862745, 0)
        colorTransferFunction.addRGBPoint(0.509803922, 1, 0.941176471, 0)
        colorTransferFunction.addRGBPoint(0.51372549, 1, 0.917647059, 0)
        colorTransferFunction.addRGBPoint(0.517647059, 1, 0.894117647, 0)
        colorTransferFunction.addRGBPoint(0.521568627, 1, 0.870588235, 0)
        colorTransferFunction.addRGBPoint(0.525490196, 1, 0.847058824, 0)
        colorTransferFunction.addRGBPoint(0.529411765, 1, 0.823529412, 0)
        colorTransferFunction.addRGBPoint(0.533333333, 1, 0.8, 0)
        colorTransferFunction.addRGBPoint(0.537254902, 1, 0.776470588, 0)
        colorTransferFunction.addRGBPoint(0.541176471, 1, 0.752941176, 0)
        colorTransferFunction.addRGBPoint(0.545098039, 1, 0.729411765, 0)
        colorTransferFunction.addRGBPoint(0.549019608, 1, 0.705882353, 0)
        colorTransferFunction.addRGBPoint(0.552941176, 1, 0.682352941, 0)
        colorTransferFunction.addRGBPoint(0.556862745, 1, 0.658823529, 0)
        colorTransferFunction.addRGBPoint(0.560784314, 1, 0.635294118, 0)
        colorTransferFunction.addRGBPoint(0.564705882, 1, 0.611764706, 0)
        colorTransferFunction.addRGBPoint(0.568627451, 1, 0.588235294, 0)
        colorTransferFunction.addRGBPoint(0.57254902, 1, 0.564705882, 0)
        colorTransferFunction.addRGBPoint(0.576470588, 1, 0.541176471, 0)
        colorTransferFunction.addRGBPoint(0.580392157, 1, 0.517647059, 0)
        colorTransferFunction.addRGBPoint(0.584313725, 1, 0.494117647, 0)
        colorTransferFunction.addRGBPoint(0.588235294, 1, 0.470588235, 0)
        colorTransferFunction.addRGBPoint(0.592156863, 1, 0.447058824, 0)
        colorTransferFunction.addRGBPoint(0.596078431, 1, 0.423529412, 0)
        colorTransferFunction.addRGBPoint(0.6, 1, 0.4, 0)
        colorTransferFunction.addRGBPoint(0.603921569, 1, 0.376470588, 0)
        colorTransferFunction.addRGBPoint(0.607843137, 1, 0.352941176, 0)
        colorTransferFunction.addRGBPoint(0.611764706, 1, 0.329411765, 0)
        colorTransferFunction.addRGBPoint(0.615686275, 1, 0.305882353, 0)
        colorTransferFunction.addRGBPoint(0.619607843, 1, 0.282352941, 0)
        colorTransferFunction.addRGBPoint(0.623529412, 1, 0.258823529, 0)
        colorTransferFunction.addRGBPoint(0.62745098, 1, 0.235294118, 0)
        colorTransferFunction.addRGBPoint(0.631372549, 1, 0.211764706, 0)
        colorTransferFunction.addRGBPoint(0.635294118, 1, 0.188235294, 0)
        colorTransferFunction.addRGBPoint(0.639215686, 1, 0.164705882, 0)
        colorTransferFunction.addRGBPoint(0.643137255, 1, 0.141176471, 0)
        colorTransferFunction.addRGBPoint(0.647058824, 1, 0.117647059, 0)
        colorTransferFunction.addRGBPoint(0.650980392, 1, 0.094117647, 0)
        colorTransferFunction.addRGBPoint(0.654901961, 1, 0.070588235, 0)
        colorTransferFunction.addRGBPoint(0.658823529, 1, 0.047058824, 0)
        colorTransferFunction.addRGBPoint(0.662745098, 1, 0.023529412, 0)
        colorTransferFunction.addRGBPoint(0.666666667, 1, 0, 0)
        colorTransferFunction.addRGBPoint(0.670588235, 1, 0, 0.023529412)
        colorTransferFunction.addRGBPoint(0.674509804, 1, 0, 0.047058824)
        colorTransferFunction.addRGBPoint(0.678431373, 1, 0, 0.070588235)
        colorTransferFunction.addRGBPoint(0.682352941, 1, 0, 0.094117647)
        colorTransferFunction.addRGBPoint(0.68627451, 1, 0, 0.117647059)
        colorTransferFunction.addRGBPoint(0.690196078, 1, 0, 0.141176471)
        colorTransferFunction.addRGBPoint(0.694117647, 1, 0, 0.164705882)
        colorTransferFunction.addRGBPoint(0.698039216, 1, 0, 0.188235294)
        colorTransferFunction.addRGBPoint(0.701960784, 1, 0, 0.211764706)
        colorTransferFunction.addRGBPoint(0.705882353, 1, 0, 0.235294118)
        colorTransferFunction.addRGBPoint(0.709803922, 1, 0, 0.258823529)
        colorTransferFunction.addRGBPoint(0.71372549, 1, 0, 0.282352941)
        colorTransferFunction.addRGBPoint(0.717647059, 1, 0, 0.305882353)
        colorTransferFunction.addRGBPoint(0.721568627, 1, 0, 0.329411765)
        colorTransferFunction.addRGBPoint(0.725490196, 1, 0, 0.352941176)
        colorTransferFunction.addRGBPoint(0.729411765, 1, 0, 0.376470588)
        colorTransferFunction.addRGBPoint(0.733333333, 1, 0, 0.4)
        colorTransferFunction.addRGBPoint(0.737254902, 1, 0, 0.423529412)
        colorTransferFunction.addRGBPoint(0.741176471, 1, 0, 0.447058824)
        colorTransferFunction.addRGBPoint(0.745098039, 1, 0, 0.470588235)
        colorTransferFunction.addRGBPoint(0.749019608, 1, 0, 0.494117647)
        colorTransferFunction.addRGBPoint(0.752941176, 1, 0, 0.517647059)
        colorTransferFunction.addRGBPoint(0.756862745, 1, 0, 0.541176471)
        colorTransferFunction.addRGBPoint(0.760784314, 1, 0, 0.564705882)
        colorTransferFunction.addRGBPoint(0.764705882, 1, 0, 0.588235294)
        colorTransferFunction.addRGBPoint(0.768627451, 1, 0, 0.611764706)
        colorTransferFunction.addRGBPoint(0.77254902, 1, 0, 0.635294118)
        colorTransferFunction.addRGBPoint(0.776470588, 1, 0, 0.658823529)
        colorTransferFunction.addRGBPoint(0.780392157, 1, 0, 0.682352941)
        colorTransferFunction.addRGBPoint(0.784313725, 1, 0, 0.705882353)
        colorTransferFunction.addRGBPoint(0.788235294, 1, 0, 0.729411765)
        colorTransferFunction.addRGBPoint(0.792156863, 1, 0, 0.752941176)
        colorTransferFunction.addRGBPoint(0.796078431, 1, 0, 0.776470588)
        colorTransferFunction.addRGBPoint(0.8, 1, 0, 0.8)
        colorTransferFunction.addRGBPoint(0.803921569, 1, 0, 0.823529412)
        colorTransferFunction.addRGBPoint(0.807843137, 1, 0, 0.847058824)
        colorTransferFunction.addRGBPoint(0.811764706, 1, 0, 0.870588235)
        colorTransferFunction.addRGBPoint(0.815686275, 1, 0, 0.894117647)
        colorTransferFunction.addRGBPoint(0.819607843, 1, 0, 0.917647059)
        colorTransferFunction.addRGBPoint(0.823529412, 1, 0, 0.941176471)
        colorTransferFunction.addRGBPoint(0.82745098, 0.992156863, 0, 0.956862745)
        colorTransferFunction.addRGBPoint(0.831372549, 0.980392157, 0, 0.968627451)
        colorTransferFunction.addRGBPoint(0.835294118, 0.968627451, 0, 0.980392157)
        colorTransferFunction.addRGBPoint(0.839215686, 0.956862745, 0, 0.992156863)
        colorTransferFunction.addRGBPoint(0.843137255, 0.941176471, 0, 1)
        colorTransferFunction.addRGBPoint(0.847058824, 0.917647059, 0, 1)
        colorTransferFunction.addRGBPoint(0.850980392, 0.894117647, 0, 1)
        colorTransferFunction.addRGBPoint(0.854901961, 0.870588235, 0, 1)
        colorTransferFunction.addRGBPoint(0.858823529, 0.847058824, 0, 1)
        colorTransferFunction.addRGBPoint(0.862745098, 0.823529412, 0, 1)
        colorTransferFunction.addRGBPoint(0.866666667, 0.8, 0, 1)
        colorTransferFunction.addRGBPoint(0.870588235, 0.776470588, 0, 1)
        colorTransferFunction.addRGBPoint(0.874509804, 0.752941176, 0, 1)
        colorTransferFunction.addRGBPoint(0.878431373, 0.729411765, 0, 1)
        colorTransferFunction.addRGBPoint(0.882352941, 0.705882353, 0, 1)
        colorTransferFunction.addRGBPoint(0.88627451, 0.682352941, 0, 1)
        colorTransferFunction.addRGBPoint(0.890196078, 0.658823529, 0, 1)
        colorTransferFunction.addRGBPoint(0.894117647, 0.635294118, 0, 1)
        colorTransferFunction.addRGBPoint(0.898039216, 0.611764706, 0, 1)
        colorTransferFunction.addRGBPoint(0.901960784, 0.588235294, 0, 1)
        colorTransferFunction.addRGBPoint(0.905882353, 0.564705882, 0, 1)
        colorTransferFunction.addRGBPoint(0.909803922, 0.541176471, 0, 1)
        colorTransferFunction.addRGBPoint(0.91372549, 0.517647059, 0, 1)
        colorTransferFunction.addRGBPoint(0.917647059, 0.494117647, 0, 1)
        colorTransferFunction.addRGBPoint(0.921568627, 0.470588235, 0, 1)
        colorTransferFunction.addRGBPoint(0.925490196, 0.447058824, 0, 1)
        colorTransferFunction.addRGBPoint(0.929411765, 0.423529412, 0, 1)
        colorTransferFunction.addRGBPoint(0.933333333, 0.4, 0, 1)
        colorTransferFunction.addRGBPoint(0.937254902, 0.376470588, 0, 1)
        colorTransferFunction.addRGBPoint(0.941176471, 0.352941176, 0, 1)
        colorTransferFunction.addRGBPoint(0.945098039, 0.329411765, 0, 1)
        colorTransferFunction.addRGBPoint(0.949019608, 0.305882353, 0, 1)
        colorTransferFunction.addRGBPoint(0.952941176, 0.282352941, 0, 1)
        colorTransferFunction.addRGBPoint(0.956862745, 0.258823529, 0, 1)
        colorTransferFunction.addRGBPoint(0.960784314, 0.235294118, 0, 1)
        colorTransferFunction.addRGBPoint(0.964705882, 0.211764706, 0, 1)
        colorTransferFunction.addRGBPoint(0.968627451, 0.188235294, 0, 1)
        colorTransferFunction.addRGBPoint(0.97254902, 0.164705882, 0, 1)
        colorTransferFunction.addRGBPoint(0.976470588, 0.141176471, 0, 1)
        colorTransferFunction.addRGBPoint(0.980392157, 0.117647059, 0, 1)
        colorTransferFunction.addRGBPoint(0.984313725, 0.094117647, 0, 1)
        colorTransferFunction.addRGBPoint(0.988235294, 0.070588235, 0, 1)
        colorTransferFunction.addRGBPoint(0.992156863, 0.047058824, 0, 1)
        colorTransferFunction.addRGBPoint(0.996078431, 0.023529412, 0, 1)
        colorTransferFunction.addRGBPoint(1, 0, 0, 1)
        return colorTransferFunction;
    },
    pointList: [
        [
            38.78619577969251,
            -0.03501410273465133,
            63.84936197258239
        ],
        [
            38.25873878639884,
            -14.668667144384555,
            68.58486459047342
        ],
        [
            36.31609282765048,
            -43.18712722893826,
            68.88700729721091
        ],
        [
            63.07012848263881,
            -12.022188036523278,
            22.412365773721135
        ],
        [
            58.02601480144822,
            11.359841980420532,
            40.75251106950447
        ],
        [
            30.016674906558727,
            -1.2297802564499878,
            71.0034179156037
        ],
        [
            34.2535877889022,
            -40.52050253039051,
            72.9817865805721
        ],
        [
            64.35484868873462,
            -47.539504175179246,
            21.995797881908494
        ],
        [
            59.89178478162993,
            18.508297066667055,
            30.35401245197226
        ],
        [
            68.06010295626714,
            -10.095454714425312,
            27.35417420347718
        ],
        [
            68.1829089432801,
            -11.143705265610171,
            -6.19843786402609
        ],
        [
            63.88630841753821,
            -44.125994961447724,
            15.861828786932854
        ],
        [
            62.56839024397845,
            -53.18804933818014,
            34.47443519426117
        ],
        [
            50.00353681106431,
            13.355099774298544,
            45.79242226851426
        ],
        [
            47.973983923814636,
            36.70212600285275,
            31.62960082727519
        ],
        [
            52.43473127150412,
            42.35830504071761,
            9.040137876233942
        ],
        [
            64.71541764897162,
            10.784568230243526,
            10.901786481192183
        ],
        [
            69.24023241366419,
            -9.28053228211052,
            8.78293150044308
        ],
        [
            69.96805587403949,
            -21.26799938487394,
            8.398383633774813
        ],
        [
            66.54336964657662,
            -7.428927976814023,
            -14.05320853722094
        ],
        [
            71.58898603832259,
            -34.446027911660686,
            0.3110516245599584
        ]
    ]
}
export default vtkUtil;